import api from "@/lib/axios";

export interface Admin {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
}

export enum AdminsKeys {
  CREATE_ADMIN = "create-admin",
  GET_ADMINS = "get-admins",
  GET_ADMIN = "get-admin",
}

export const createAdmin = async (payload: Partial<Admin>) => {
  const response = await api.post("/admins", payload);
  return response.data as { user: Admin; ticketUrl: string };
};

export const getAdmins = async () => {
  const response = await api.get("/admins");
  return response.data as Admin[];
};

export const getAdmin = async (id: string) => {
  const response = await api.get(`/admins/${id}`);
  return response.data as Admin;
};

export const updateAdmin = async (id: string, updatedAdmin: Partial<Admin>) => {
  const response = await api.patch(`/admins/${id}`, updatedAdmin);
  return response.data as Admin;
};
